import { API_URLS } from "../../../../Constants/api.constants";
import { Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { IoIosInformationCircle, IoMdArrowBack } from "react-icons/io";
import Spinner from "../../Spinner";
import { ToastComponent } from "../../ToastComponent";

import { Modal } from "react-bootstrap";
import { FaCar } from "react-icons/fa";

// Icons
import { AiOutlineSend } from "react-icons/ai";
import { BiBox } from "react-icons/bi";

// services
import {
  toDateTime,
  toDateTimeISOStringFormat,
} from "../../../../Services/string.service";
import { vehicleService } from "../../../../Services/vehicle.service";
import { reportService } from "../../../../Services/report.service";

// syncfusion
import { DataManager, WebApiAdaptor } from "@syncfusion/ej2-data";
import "@syncfusion/ej2-react-calendars/styles/tailwind.css";
import "./syncfusion-grid-overrides.css";
import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  PdfExport,
  Resize,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import { useTranslation } from "react-i18next";
import { HiOutlineRectangleGroup } from "react-icons/hi2";
import { Filters } from "../../../../components/Filters";
import { storageKeys } from "../../../../Constants/storage.key";
import { useSelected } from "../../../../contexts/SelectedContext";
import { storage } from "../../../../Services/storage.service";
import SyncFusionDateTimePicker from "../../../Components/SyncFusionDateTimePicker/SyncFusionDateTimePicker";
import ReportDropDown from "../../DropDownButton/ReportDropDown";
import PositionsMap from "../../Maps/PositionsMap";
import ActionMenu from "./ActionMenu";
import { SearchDetails } from "./SearchDetails";
import LayoutToggle from "../../../../components/LayoutToggle";

const PaginatedTableFleetPositions = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isLocalizationPage = location.pathname === '/localization';
  const isPositionsPage = props.activeTab === "positions";
  const useReportService =
    props.useReportService === true || isLocalizationPage || isPositionsPage;

  const { vehicleSelected: reduxVehicleSelected } = useSelector(
    (rootReducer) => rootReducer.vehicleSelectedReducer
  );

  // Allow parent to pass the selected vehicle (CustomerServicePage). Prefer prop over redux.
  const vehicleSelected = props.selectedVehicle ?? reduxVehicleSelected;

  const [registersMap, setRegistersMap] = useState(props.diaryPositions || []);
  const [visible, setVisible] = useState(false);

  const showDialog = () => setVisible(true);
  const hideDialog = () => setVisible(false);

  const [dataLoading, setDataLoading] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setHours(0, 0, 1, 0);
    return d;
  });
  const [startMaintenanceDate, setStartMaintenanceDate] = useState(null);
  const [endMaintenanceDate, setEndMaintenanceDate] = useState(null);
  const [localUnderMaintenace, setLocalUnderMaintenace] = useState(
    props.underMaintenace
  );
  const [endDate, setEndDate] = useState(new Date());

  const [dateStartCommands, setDateStartCommands] = useState(null);
  const [dateEndCommands, setDateEndCommands] = useState(null);

  const [alertVehicleMaintencance, setAlertVehicleMaintencance] =
    useState(false);
  const [toastParams, setToastParams] = useState("");

  const [data, setData] = useState([]);

  // GRID
  const [gridPageSettings, setGridPageSettings] = useState({
    pageSize: 10,
    currentPage: 1,
    totalRecordsCount: 0,
  });
  const [gridData, setGridData] = useState([]);
  const gridRef = useRef();
  const isPagingByCode = useRef(false);
  const hasRefreshedOnCreateRef = useRef(false);

  const [dataGroup, setDataGroup] = useState([]);
  const [dataVehicle, setDataVehicle] = useState([]);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [isManualSelection, setIsManualSelection] = useState(false);
  const { selectedValues, setSelectedValues } = useSelected();

  const selectedGroup = selectedValues.veiculos?.[0] || null;
  const selectedVehicle = selectedValues.veiculosGroups?.[0] || null;
  const showTopFilters = props.showTopFilters !== false;
  const showBackButton = props.showBackButton !== false;

  const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);
  const [showCommandsModal, setShowCommandsModal] = useState(false);
  const [showAvailableCommandsModal, setShowAvailableCommandsModal] =
    useState(false);

  const showMaintenance = () => setShowMaintenanceModal(true);
  const hideMaintenance = () => setShowMaintenanceModal(false);

  const showCommands = () => setShowCommandsModal(true);
  const hideCommands = () => setShowCommandsModal(false);

  const [availableCommands, setAvailableCommands] = useState([{}]);
  const showAvailableCommands = () => setShowAvailableCommandsModal(true);
  const hideAvailableCommands = () => setShowAvailableCommandsModal(false);

  const [maintenanceMessage, setMaintenanceMessage] = useState("");

  const [startCommandsDate, setStartCommandsDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 365))
  );
  const [endCommandsDate, setEndCommandsDate] = useState(new Date());

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [commandToSend, setCommandToSend] = useState(null);
  const [selectedVehicleName, setSelectedVehicleName] = useState("");
  const [selectedActionRow, setSelectedActionRow] = useState(null);

  // PoC: Layout mode for split/map-only/grid-only visualization
  const [layoutMode, setLayoutMode] = useState("split"); // 'split', 'grid-only', 'map-only'

  const baseColumns = props.columns ?? [];
  const baseFields = props.fields ?? [];

  const buildColumnEntries = (includeLocation) => {
    const entries = [];
    const seenFields = new Set();

    baseColumns.forEach((column, index) => {
      const field = baseFields[index];

      if (!field || seenFields.has(field)) {
        return;
      }

      if (!includeLocation && field === "location") {
        return;
      }

      seenFields.add(field);
      entries.push({ column, field });
    });

    if (includeLocation && !seenFields.has("location")) {
      entries.push({ column: "Endereço", field: "location" });
    }

    return entries;
  };

  const effectiveEntries = buildColumnEntries(layoutMode === "grid-only");
  const effectiveColumns = effectiveEntries.map((entry) => entry.column);
  const effectiveFields = effectiveEntries.map((entry) => entry.field);

  const contextMenuItems = [
    {
      text: "Criar Ponto de Visita",
      id: "editar-localizacao",
      iconCss: "e-icons e-eye",
    },
  ];

  // 🧩 Função chamada ao clicar no ícone de envio
  const handleOpenConfirmModal = (command) => {
    setCommandToSend(command);
    setSelectedVehicleName(vehicleSelected.plate || "Veículo desconhecido");
    setShowConfirmModal(true);
  };

  // 🧩 Função chamada quando o usuário confirma o envio
  const handleConfirmSend = () => {
    if (commandToSend) {
      sendVehicleCommand(commandToSend);
    }
    setShowConfirmModal(false);
  };

  const handleMaintenanceClick = async (vehicleId) => {
    await handleCallVehicleMaintenance(vehicleId);
    setMaintenanceMessage("Veículo em manutenção");
  };

  // Função para buscar grupos de veículos
  const fetchVehicleGroups = async () => {
    try {
      setFiltersLoading(true);
      const groups = await vehicleService.fetchGroups();
      setDataGroup(groups);

      if (groups && groups.length === 1) {
        const responseVehicles = await vehicleService.fetchVehicles(
          groups[0].vehicleGroupId
        );
        if (responseVehicles) {
          setDataVehicle(responseVehicles);
        }
      } else {
        const responseVehicles = await vehicleService.fetchVehicles(0);
        if (responseVehicles) {
          setDataVehicle(responseVehicles);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setFiltersLoading(false);
    }
  };

  // Função para buscar veículos por grupo
  const fetchVehiclesByGroup = async (groupId) => {
    try {
      setFiltersLoading(true);
      const vehicles = await vehicleService.fetchVehicles(groupId);
      setDataVehicle(vehicles);
    } catch (error) {
      console.log(error);
    } finally {
      setFiltersLoading(false);
    }
  };

  useEffect(() => {
    if (showTopFilters) {
      fetchVehicleGroups();
    }
    localUnderMaintenace === "S" &&
      setMaintenanceMessage("Veículo em manutenção");
  }, [showTopFilters]);

  // Inicializa com o veículo selecionado da tela anterior
  useEffect(() => {
    if (!showTopFilters || !vehicleSelected?.vehicleId) return;

    const initializeWithSelectedVehicle = async () => {
      try {
        if (dataGroup.length === 0) {
          const groups = await vehicleService.fetchGroups();
          setDataGroup(groups);
        }

        setSelectedValues((prev) => ({
          ...prev,
          veiculos: vehicleSelected.vehicleGroupId
            ? [vehicleSelected.vehicleGroupId]
            : [],
          veiculosGroups: [vehicleSelected.vehicleId],
        }));

        if (vehicleSelected.vehicleGroupId) {
          const groupVehicles = await vehicleService.fetchVehicles(
            vehicleSelected.vehicleGroupId
          );
          setDataVehicle(groupVehicles || []);
        } else {
          const allVehicles = await vehicleService.fetchVehicles(0);
          setDataVehicle(allVehicles || []);
        }
      } catch (error) {
        console.log(error);
      }
    };

    initializeWithSelectedVehicle();
  }, [vehicleSelected?.vehicleId, setSelectedValues, showTopFilters]);

  // Atualiza veículos quando o grupo selecionado muda (apenas se for seleção manual)
  useEffect(() => {
    if (!showTopFilters) return;

    if (selectedGroup !== null && isManualSelection) {
      fetchVehiclesByGroup(selectedGroup);
      setIsManualSelection(false);
    }
  }, [selectedGroup, isManualSelection, showTopFilters]);

  // Atualiza dados quando veículo selecionado muda (apenas se for seleção manual)
  useEffect(() => {
    if (!showTopFilters) return;

    if (selectedVehicle && selectedVehicle !== "TODOS" && isManualSelection) {
      const vehicleId = selectedVehicle;
      if (vehicleId && vehicleId !== 0) {
        const selectedVehicleObj = dataVehicle.find(
          (v) =>
            v.vehicleId?.toString() === vehicleId.toString() ||
            v.groupVehicleId?.toString() === vehicleId.toString()
        );

        if (selectedVehicleObj) {
          dispatch({ type: "vehicleSelected", value: selectedVehicleObj });
          setIsManualSelection(false);
        }
      }
    }
  }, [selectedVehicle, dataVehicle, dispatch, isManualSelection, showTopFilters]);

  // Manutenção
  const [isPaging, setIsPaging] = useState(false);

  const token = storage.get(storageKeys.access_and_token);
  const [dataGridPositions, setDataGridPositions] = useState(null);
  const [diaryPositions, setDiaryPositions] = useState(props.diaryPositions);
  const [handleClick, setHandleClick] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const selectedVehicleId = vehicleSelected?.clientId ?? vehicleSelected?.vehicleId ;

  const buildPositionsQuery = ({
    vehicleId,
    groupId,
    startDate,
    endDate,
    onlyEvents,
    pageNumber,
    pageSize,
  }) => {
    const queryString = new URLSearchParams();

    if (vehicleId !== undefined && vehicleId !== null) {
      queryString.append("VehicleId", vehicleId);
    }
    if (groupId !== undefined && groupId !== null) {
      queryString.append("GroupId", groupId);
    }
    if (startDate) {
      queryString.append("StartDate", startDate);
    }
    if (endDate) {
      queryString.append("EndDate", endDate);
    }

    const normalizedOnlyEvents = `${onlyEvents ?? ""}`.trim().toUpperCase();
    if (normalizedOnlyEvents && normalizedOnlyEvents !== "N") {
      queryString.append("OnlyEvents", onlyEvents);
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryString.append("PageNumber", pageNumber);
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryString.append("PageSize", pageSize);
    }

    return queryString.toString();
  };

  const buildPositionsUrl = (pageNumber = 1, pageSize = gridPageSettings.pageSize) => {
    if (!selectedVehicleId || !useReportService) return null;

    const payload = {
      vehicleId: selectedVehicleId,
      groupId: selectedGroup?.value ?? 0,
      startDate: startDate
        ? toDateTimeISOStringFormat(new Date(startDate)).replace("Z", "")
        : null,
      endDate: endDate
        ? toDateTimeISOStringFormat(new Date(endDate)).replace("Z", "")
        : null,
      onlyEvents: props.onlyEvents ? "S" : "N",
      pageNumber,
      pageSize,
    };

    const query = buildPositionsQuery(payload);

    return query
      ? `${API_URLS.REPORTS}/vehicle-positions/positions?${query}`
      : null;
  };

  const hostUrl = buildPositionsUrl();
  class CustomAdaptor extends WebApiAdaptor {
    processQuery(dm, query) {
      const original = super.processQuery(dm, query);

      // Extrai $skip e $top antes de removê-los para converter para PageNumber/PageSize
      const skipMatch = original.url.match(/[?&]\$skip=(\d+)/);
      const topMatch = original.url.match(/[?&]\$top=(\d+)/);
      const skip = skipMatch ? parseInt(skipMatch[1], 10) : 0;
      const top = topMatch ? parseInt(topMatch[1], 10) : null;

      // Remove parâmetros OData adicionados pelo Syncfusion
      original.url = original.url
        .replace(/[&?]\$inlinecount=[^&]*/g, "")
        .replace(/[&?]\$skip=[^&]*/g, "")
        .replace(/[&?]\$top=[^&]*/g, "");

      // Converte paginação OData ($skip/$top) para os parâmetros do backend (PageNumber/PageSize)
      if (top !== null) {
        const pageNumber = Math.floor(skip / top) + 1;
        original.url = original.url
          .replace(/([?&])PageNumber=\d+/g, `$1PageNumber=${pageNumber}`)
          .replace(/([?&])PageSize=\d+/g, `$1PageSize=${top}`);
      }

      return original;
    }

    processResponse(response) {
      const data = response.items ?? [];
      const count = response.paging?.totalLines ?? response.totalLines ?? 0;

      return { result: data, count: count };
    }
  }

  useEffect(() => {
    if (props.activeTab === "positions") {
      if (hostUrl && token?.token) {
        const dataManagerInstance = new DataManager({
          url: hostUrl,
          adaptor: new CustomAdaptor(),
          headers: [{ Authorization: `Bearer ${token.token}` }],
        });
        setDataGridPositions(dataManagerInstance);
      }
    }
  }, [props.activeTab, hostUrl]);

  const calculateInitialPageSize = () => {
    const fallbackRowHeight = 30; // rowHeight explícito do GridComponent

    const gridEl = document.getElementById("gridcomp");
    if (!gridEl) {
      // Grid ainda não montado — fallback percentual
      return Math.floor((window.innerHeight * 0.65 - 20) / fallbackRowHeight) || 10;
    }

    // Overhead interno: cabeçalho de colunas + barra de paginação
    const headerEl = gridEl.querySelector(".e-gridheader");
    const pagerEl  = gridEl.querySelector(".e-gridpager");
    const headerHeight = headerEl?.getBoundingClientRect().height ?? 42;
    const pagerHeight  = pagerEl?.getBoundingClientRect().height  ?? 42;

    // Altura real por linha (usa rowHeight={30} do componente, confirma pelo DOM)
    const firstRow = gridEl.querySelector(".e-row");
    const actualRowHeight = firstRow
      ? firstRow.getBoundingClientRect().height
      : fallbackRowHeight;

    // Espaço abaixo do grid até o fim do scroll container
    const px = (el, prop) => parseFloat(el ? getComputedStyle(el)[prop] : 0) || 0;
    const belowGrid =
      px(gridEl.closest(".grid-component"),  "paddingBottom") +
      px(gridEl.closest(".accordion-body"),  "paddingBottom") +
      px(gridEl.closest(".accordion-item"),  "marginBottom")  +
      px(gridEl.closest(".container-xxl"),   "paddingBottom") +
      px(document.querySelector(".movyx-content"), "paddingBottom");

    const { top } = gridEl.getBoundingClientRect();
    const available = window.innerHeight - top - headerHeight - pagerHeight - belowGrid;
    return Math.max(1, Math.floor(available / actualRowHeight + 0.5));
  };

  const triggerClick = (lat, lng) => {
    const index = registersMap.findIndex(
      (item) => item.latitude === lat && item.longitude === lng
    );

    if (index !== -1) {
      setSelectedIndex(index);
      setHandleClick(true);
    }
  };

  const openVisitControl = (item) => {
    const lat = encodeURIComponent(item.latitude);
    const lng = encodeURIComponent(item.longitude);
    navigate("/visitpoint", { state: { lat, lng } });
  };

  const onContextMenuClick = async (args) => {
    const selectedRow = selectedActionRow || gridRef.current?.getSelectedRecords?.()?.[0];
    if (!selectedRow) return;

    switch (args.item.id) {
      case "editar-localizacao":
        openVisitControl(selectedRow);
        break;
      default:
        break;
    }
  };

  const renderMoreButton = (rowData) => {
    return (
      <ActionMenu
        rowData={rowData}
        onClick={(e) => {
          setSelectedActionRow(rowData);
          gridRef.current?.contextMenuModule?.contextMenu?.open(
            e.clientY,
            e.clientX
          );
        }}
      />
    );
  };

  const onHandled = () => setHandleClick(false);

  useEffect(() => {
    const handleResize = () => {
      if (props.activeTab === "positions") {
        const pageSize = calculateInitialPageSize();

        setGridPageSettings((prev) => ({
          ...prev,
          pageSize,
          currentPage: 1,
        }));
      }
    };

    // Chama logo de cara quando ativa o tab
    if (props.activeTab === "positions") {
      handleResize();
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [props.activeTab]);

  const fetchPositions = async (vehicleId, pageNumber = 1, customPageSize) => {
    
    setDataLoading(true);

    try {
      const pageSizeToUse = customPageSize ?? gridPageSettings.pageSize;
      const payload = {
        vehicleId,
        groupId: selectedGroup?.value ?? 0,
        startDate: startDate
          ? toDateTimeISOStringFormat(new Date(startDate)).replace("Z", "")
          : null,
        endDate: endDate
          ? toDateTimeISOStringFormat(new Date(endDate)).replace("Z", "")
          : null,
        onlyEvents: props.onlyEvents ? "S" : "N",
        pageSize: pageSizeToUse,
        pageNumber,
      };

      const result = useReportService
        ? await reportService.fetchVehiclesPositionsPaged(payload)
        : await vehicleService.fetchVehiclePositions(vehicleId, payload);

      setGridData(result?.vehiclePositions || []);

      // Adapte os dados para o formato esperado
      const adaptedData = {
        result: result?.items || [],
        count: Number(result?.paging?.totalLines ?? result?.totalLines ?? 0),
      };

      setGridData(adaptedData);

      setGridPageSettings((prev) => ({
        ...prev,
        currentPage: pageNumber,
        totalRecordsCount: adaptedData.count,
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setDataLoading(false);
    }
  };

  const fetchPositionsMap = async (vehicleId, pageNumber = 0, pageSize = 0) => {
    setDataLoading(true);
    try {
      const payload = {
        vehicleId,
        groupId: selectedGroup?.value ?? 0,
        startDate: startDate
          ? toDateTimeISOStringFormat(new Date(startDate)).replace("Z", "")
          : null,
        endDate: endDate
          ? toDateTimeISOStringFormat(new Date(endDate)).replace("Z", "")
          : null,
        onlyEvents: props.onlyEvents ? "S" : "N",
        pageNumber,
        pageSize,
      };

      const positions = useReportService
        ? await reportService.fetchVehiclesPositionsPaged(payload)
        : await vehicleService.fetchVehiclePositions(vehicleId, payload);

      const list = positions?.items ?? [];
      setRegistersMap(list);
      return list;
    } catch (error) {
      console.error(error);
    } finally {
      setDataLoading(false);
    }
  };

  const vehicleMaintenace = async (vehicleId) => {
    try {
      if (localUnderMaintenace === "N") {
        const payload = {
          dateStart: startMaintenanceDate
            ? toDateTimeISOStringFormat(new Date(startMaintenanceDate)).replace(
                "Z",
                ""
              )
            : null,
          dateEnd: endMaintenanceDate
            ? toDateTimeISOStringFormat(new Date(endMaintenanceDate)).replace(
                "Z",
                ""
              )
            : null,
        };

        const response = await vehicleService.ChangeVehicleMaintenace(
          vehicleId,
          payload
        );

        if (response) {
          setToastParams(
            JSON.stringify({
              show: true,
              title: "Sucesso!",
              body: `Iniciado manutenção do veículo ${vehicleSelected.plate}`,
              color: "Success",
            })
          );
        }

        setLocalUnderMaintenace("S");
      } else {
        const payload = {
          dateStart: null,
          dateEnd: null,
        };

        const response = await vehicleService.DeleteVehicleMaintenace(
          vehicleId,
          payload
        );

        if (response) {
          setToastParams(
            JSON.stringify({
              show: true,
              title: "Atenção!",
              body: `Veículo ${vehicleSelected.plate} retirado da manutenção`,
              color: "Warning",
            })
          );
        }

        setLocalUnderMaintenace("N");
      }

      setVisible(false);
    } catch (error) {
      console.error(error);
    } finally {
      hideMaintenance();
    }
  };

  const toFormattedDate = (date) => {
    if (!date) return null;

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    const formatted = `${year}/${month}/${day} ${hours}:${minutes}`;
    return encodeURIComponent(formatted); // Isso transforma espaço em %20 e outros caracteres
  };

  const search = async () => {
    
    console.log("PaginatedTableFleetPositions.search called", { vehicleSelected, startDate, endDate });

    const formattedStartDate = toFormattedDate(startDate);
    const formattedEndDate = toFormattedDate(endDate);

    const urlPaging = buildPositionsUrl(1, 15) ||
      `${API_URLS.REPORTS}/vehicle-positions/positions?${buildPositionsQuery({
        vehicleId: vehicleSelected.clientId ?? vehicleSelected.vehicleId,
        groupId: selectedGroup?.value ?? 0,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        onlyEvents: props.onlyEvents ? "S" : "N",
        pageNumber: 1,
        pageSize: 15,
      })}`;

    if (token) {
      const dm = new DataManager({
        url: urlPaging,
        adaptor: new CustomAdaptor(),
        headers: [{ Authorization: `Bearer ${token.token}` }],
      });
      setDataGridPositions(dm);

      // Garantir que tanto o grid quanto o mapa sejam populados
      try {
        await fetchPositions(vehicleSelected.clientId ?? vehicleSelected.vehicleId, 1);
      } catch (err) {
        console.error("fetchPositions failed:", err);
      }

      try {
        await fetchPositionsMap(vehicleSelected.clientId ?? vehicleSelected.vehicleId);
      } catch (err) {
        console.error("fetchPositionsMap failed:", err);
      }
    }
  };

  const refresh = async () => {
    
    const formattedStartDate = toFormattedDate(startDate);
    const formattedEndDate = toFormattedDate(endDate);

    const urlPaging = buildPositionsUrl(1, 15) ||
      `${API_URLS.REPORTS}/vehicle-positions/positions?${buildPositionsQuery({
        vehicleId: vehicleSelected.clientId ?? vehicleSelected.vehicleId,
        groupId: selectedGroup?.value ?? 0,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        onlyEvents: props.onlyEvents ? "S" : "N",
        pageNumber: 1,
        pageSize: 15,
      })}`;

    if (token && vehicleSelected?.vehicleId || vehicleSelected?.clientId) {
      const dm = new DataManager({
        url: urlPaging,
        adaptor: new CustomAdaptor(),
        headers: [{ Authorization: `Bearer ${token.token}` }],
      });
      setDataGridPositions(dm);
      await fetchPositionsMap(vehicleSelected.clientId ?? vehicleSelected.vehicleId);
    }
  };

  useEffect(() => {
    if (!isLocalizationPage) return;
    if (hasRefreshedOnCreateRef.current) return;
    if (props.dataLoading) return;
    if (!gridRef.current) return;
    if (!dataGridPositions) return;
    if (!selectedVehicleId) return;

    hasRefreshedOnCreateRef.current = true;
    refresh();
  }, [
    isLocalizationPage,
    props.dataLoading,
    dataGridPositions,
    selectedVehicleId,
  ]);

  const clear = () => {
    const d = new Date();
    d.setHours(0, 0, 1, 0);
    setStartDate(d);
    setEndDate(new Date());
  };

  const onMap = (item) => {
    if (item.latitude && item.longitude) {
      const suffixLat = item.latitude.toString().includes("-") ? "S" : "N";
      const suffixLon = item.longitude.toString().includes("-") ? "W" : "E";

      var url = `https://www.google.com.br/maps?q=${item.latitude
        .toString()
        .replace("-", "")}${suffixLat}+${item.longitude
        .toString()
        .replace("-", "")}${suffixLon}`;
    }
    window.open(url, "_blank", "popup");
  };

  const editing = {
    allowEditing: true,
    allowDeleting: true,
    allowAdding: false,
    mode: "Dialog",
  };

  const renderField = (field) => (props) => {
    const value = props[field];

    if (field === "generationDate") {
      return (
        <span
          onClick={() => triggerClick(props.latitude, props.longitude)}
          style={{ fontSize: "13px", cursor: "pointer" }}
        >
          {toDateTime(value)}
        </span>
      );
    }

    if (field === "statusDescription") {
      return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-ignition-${vehicleSelected.vehicleId}`}>
              {props.statusDescription}
            </Tooltip>
          }
        >
          <div
            style={{
              backgroundColor: props.statusColor,
              width: 15,
              height: 15,
              marginLeft: "12px",
            }}
          />
        </OverlayTrigger>
      );
    }

    if (field === "ignition") {
      let style = {
        width: "20px",
        height: "20px",
        cursor: "help",
      };
      return (
        <>
          <td style={{ width: "100px", paddingLeft: "13px" }}>
            <div style={style}>
              {props.ignition === "Ligado" ? (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id={`tooltip-location-${vehicleSelected.vehicleId}`}
                    >
                      {props.ignition}
                    </Tooltip>
                  }
                >
                  <div
                    data-tooltip-id={`tooltip-${vehicleSelected.vehicleId}`}
                    data-tooltip-content="Ligado"
                  >
                    <img
                      src="/images/icons/opened.png"
                      alt="Ligado"
                      style={{ width: "24px", marginLeft: "0px" }}
                    />
                  </div>
                </OverlayTrigger>
              ) : props.ignition === "Desligado" ? (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id={`tooltip-location-${vehicleSelected.vehicleId}`}
                    >
                      {props.ignition}
                    </Tooltip>
                  }
                >
                  <div
                    data-tooltip-id={`tooltip-${vehicleSelected.vehicleId}`}
                    data-tooltip-content="Desligado"
                  >
                    <img
                      src="/images/icons/closed.png"
                      alt="Desligado"
                      style={{ width: "24px", marginLeft: "0px" }}
                    />
                  </div>
                </OverlayTrigger>
              ) : (
                <div style={{ cursor: "default" }}>{props.ignition}</div>
              )}
            </div>
          </td>
        </>
      );
    }

    if (field === "speed") {
      if (props.speedStatusDescription) {
        return (
          <>
            <td>
              <div>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-speed-${vehicleSelected.vehicleId}`}>
                      {props.speedStatusDescription}
                    </Tooltip>
                  }
                >
                  <div data-tooltip-id={`tooltip-${vehicleSelected.vehicleId}`}>
                    <span
                      className="d-inline-block"
                      style={{
                        fontWeight: ["1", "2", "3", "4"].includes(
                          props.speedStatus
                        )
                          ? "bold"
                          : "normal",
                        color:
                          props.speedStatus === "1" || props.speedStatus === "2"
                            ? "red"
                            : props.speedStatus === "3" ||
                              props.speedStatus === "4"
                            ? "orange"
                            : "inherit",
                        fontSize: "13px",
                      }}
                    >
                      {value.toFixed(2)} Km/h
                    </span>
                  </div>
                </OverlayTrigger>
              </div>
            </td>
          </>
        );
      } else {
        return (
          <span
            className="d-inline-block"
            style={{
              fontWeight: ["1", "2", "3", "4"].includes(props.speedStatus)
                ? "bold"
                : "normal",
              color:
                props.speedStatus === "1" || props.speedStatus === "2"
                  ? "red"
                  : props.speedStatus === "3" || props.speedStatus === "4"
                  ? "orange"
                  : "inherit",
              fontSize: "13px",
            }}
          >
            {value.toFixed(2)} Km/h
          </span>
        );
      }
    }

    if (field === "location") {
      const mapsUrl = value
        ? `https://www.google.com/maps?q=${encodeURIComponent(value)}`
        : null;

      return (
        <>
          <td>
            <div>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-speed-${vehicleSelected.vehicleId}`}>
                    {props.location}
                  </Tooltip>
                }
              >
                <div data-tooltip-id={`tooltip-${vehicleSelected.vehicleId}`}>
                  {mapsUrl ? (
                    <a
                      href={mapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Abrir endereço no Google Maps"
                      style={{ color: "var(--text-primary)", textDecoration: "underline" }}
                    >
                      {value}
                    </a>
                  ) : (
                    <span>{value}</span>
                  )}
                </div>
              </OverlayTrigger>
            </div>
          </td>
        </>
      );
    }

    if (field === "vehicleId") {
      if (props.latitude && props.longitude) {
        return (
          <>
            <td
              className="action-table-col"
              style={{ width: "50px", paddingLeft: "25px" }}
            >
              <div className="row">
                <div className="col-6">
                  <a
                    href={`https://www.google.com/maps?q=${props.latitude},${props.longitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Abrir no Google Maps"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Google_Maps_icon_%282015-2020%29.svg/2048px-Google_Maps_icon_%282015-2020%29.svg.png"
                      width={25}
                      height={25}
                      alt="imagem-mapa"
                    />
                  </a>
                </div>
              </div>
            </td>
          </>
        );
      } else {
        return (
          <>
            <td
              className="action-table-col"
              style={{ width: "40px", paddingLeft: "30px" }}
            >
              <div className="row">
                <div className="col-6"></div>
                <div className="col-6"></div>
              </div>
            </td>
          </>
        );
      }
    }

    if (field === "levelEvent") {
      if (props.levelEvent === "") {
        return null;
      }

      const eventColor =
        props.levelEvent === "1" ? "red"
        : props.levelEvent === "2" ? "orange"
        : props.levelEvent === "3" ? "blue"
        : "inherit";

      // Modo "Apenas Grid": mostra o texto do evento com a mesma cor do ícone
      if (layoutMode === "grid-only") {
        return (
          <span style={{ color: eventColor, fontSize: "13px" }}>
            {props.event}
          </span>
        );
      }

      // Modos "Grid + Mapa" e "Apenas Mapa": mantém o ícone com tooltip
      return (
        <>
          <td
            style={{
              width: "100px",
              paddingLeft: "6px",
              display: "flex",
              alignItems: "center",
              gap: 20,
            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-speed-${vehicleSelected.vehicleId}`}>
                  {props.event}
                </Tooltip>
              }
            >
              <div
                data-tooltip-id={`tooltip-${vehicleSelected.vehicleId}`}
                data-tooltip-content="Ligado"
              >
                <IoIosInformationCircle
                  style={{ color: eventColor }}
                  size={18}
                />
              </div>
            </OverlayTrigger>
          </td>
        </>
      );
    }

    // IoIosInformationCircle

    // Fallback padrão
    return <span>{value}</span>;
  };

  const renderFilter = (props) => {
    if (!props?.field || props.field === "generationDate") return null;
    return null; // Ou seu filtro customizado
  };

  const getColumnProps = (field, index, props, renderField, renderFilter) => {
    const fieldExists = field == props.fields[index];
    const isFullyOpenGrid = layoutMode === "grid-only";
    const isSplitWithMap = layoutMode === "split";

    let baseProps = {};
    baseProps = {
      locale: "pt-BR",
      key: field,
      field,
      headerText: props.columns[index],
      width:
        field === "generationDate"
          ? isSplitWithMap
            ? 205
            : 170
          : field === "location"
          ? isFullyOpenGrid
            ? 420
            : 200
          : field === "statusDescription"
          ? isSplitWithMap
            ? 68
            : 78
          : field === "ignition"
          ? isSplitWithMap
            ? 60
            : 72
          : field === "levelEvent"
          ? isFullyOpenGrid
            ? 220
            : isSplitWithMap
            ? 82
            : 92
          : field === "speed"
          ? isSplitWithMap
            ? 58
            : 72
          : null,
      textAlign: "Left",
      editType: "dropdownedit",
      filterTemplate: field !== "generationDate" ? renderFilter : undefined,
    };

    if (field === "generationDate") {
      baseProps.textAlign = "Left";
      baseProps.type = "dateTime"; // informa o tipo
      baseProps.format = { type: "dateTime", format: "dd/MM/yyyy HH:mm:ss" }; // formata como desejado
      baseProps.allowFiltering = false;
      baseProps.allowSorting = false;
      baseProps.valueAccessor = (field, data) => {
        if (!data[field] || data[field] === "0001-01-01T00:00:00") return null;
        return new Date(data[field]); // converte string para objeto Date real
      };
    }

    if (fieldExists) {
      baseProps.template = renderField(field);
    }

    return baseProps;
  };

  const handleCallVehicleMaintenance = async (vehicleId) => {
    await vehicleMaintenace(vehicleId);
  };

  const isManualPagingRef = useRef(false);

  const handleActiveTabGrid = () => {
    dispatch({ type: "title", value: t("TITLE.MY_FLEET") });
    // Datas NÃO são limpadas ao voltar — evita busca sem filtro de período
    props.chooseDisplay("gridAndMap", 0);
  };

  const handleActiveTabMap = async () => {
    const activeTab = "map";
    props.chooseDisplay(activeTab, vehicleSelected.vehicleId);
  };

  const handleActiveCommands = async () => {
    showCommands();
  };

  const handleShowCommands = async () => {
    try {
      const result = await vehicleService.fetchVehicleCommands(
        vehicleSelected.vehicleId
      );
      setAvailableCommands(result);
      showAvailableCommands();
    } catch (error) {
      console.log(error);
    }
  };

  const sendVehicleCommand = async (command) => {
    try {
      const payload = {
        vehicleId: vehicleSelected.vehicleId,
        commandId: command.commandId,
        parameters: null,
      };

      const response = await vehicleService.sendCommand(payload);

      if (!response.error) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: `Comando enviado`,
            body: command.descriptionCommand,
            color: "primary",
          })
        );
      } else {
        setToastParams(
          JSON.stringify({
            show: true,
            title: `Falha ao enviar comando`,
            body: command.descriptionCommand,
            color: "danger",
          })
        );
      }
    } catch (error) {
      console.error(error);
      setToastParams(
        JSON.stringify({
          show: true,
          title: `Falha ao enviar comando`,
          body: command.descriptionCommand,
          color: "danger",
        })
      );
    }
  };

  const handleSearchCommands = (startDate, endDate) => {
    setShowCommandsModal(false);

    const activeTab = "commands";

    dispatch({ type: "activeTab", value: activeTab });

    props.chooseDisplay(activeTab, vehicleSelected.vehicleId);

    props.setCommandDates(startDate, endDate);
  };

  const handleActiveMaintenace = async () => {
    const activeTab = "maintenace";
    dispatch({ type: "activeTab", value: activeTab });
    showMaintenance();
  };

  const handleStartDateChange = (e) => {
    const selectedDate = e;
    setStartMaintenanceDate(selectedDate);

    if (
      endMaintenanceDate &&
      selectedDate &&
      new Date(endMaintenanceDate) < new Date(selectedDate)
    ) {
      setEndMaintenanceDate(null);
    }
  };

  const handleEndDateChange = (e) => {
    const selectedDate = e; // safe access

    if (
      selectedDate &&
      startMaintenanceDate &&
      new Date(selectedDate) < new Date(startMaintenanceDate)
    ) {
      setToastParams(
        JSON.stringify({
          show: true,
          title: "Atenção!",
          body: "Data final não pode ser menor que a data inicial!",
          color: "Danger",
        })
      );
      setEndMaintenanceDate(null);
      return;
    }

    setEndMaintenanceDate(selectedDate);
  };

  // const handleStartDateChangeCommands = (e) => {
  //   const selectedDate = e;
  //   setStartCommandsDate(selectedDate);

  //   if (
  //     endCommandsDate &&
  //     selectedDate &&
  //     new Date(endCommandsDate) < new Date(selectedDate)
  //   ) {
  //     setEndCommandsDate(null);
  //   }
  // };

  // const handleEndDateChangeCommands = (e) => {
  //   const selectedDate = e; // safe access

  //   if (
  //     selectedDate &&
  //     startCommandsDate &&
  //     new Date(selectedDate) < new Date(startCommandsDate)
  //   ) {
  //     setToastParams(
  //       JSON.stringify({
  //         show: true,
  //         title: "Atenção!",
  //         body: "Data final não pode ser menor que a data inicial!",
  //         color: "Danger",
  //       })
  //     );
  //     setEndCommandsDate(null);
  //     return;
  //   }

  //   setEndCommandsDate(selectedDate);
  // };

  const handleActiveTabMapPositions = async () => {
    const positions = await fetchPositionsMap(vehicleSelected.clientId ?? vehicleSelected.vehicleId);
    await props.handleShowPositionMap(positions);
  };

  useEffect(() => {
    if (props.activeTab === "positions" && vehicleSelected.vehicleId) {
      // Reseta datas para hoje ao trocar de veículo (evita período muito longo)
      const d = new Date();
      d.setHours(0, 0, 1, 0);
      setStartDate(d);
      setEndDate(new Date());
      handleActiveTabMapPositions();
    }
  }, [vehicleSelected.vehicleId]); // dispara quando vehicleId mudar

  useEffect(() => {
    setLocalUnderMaintenace(props.underMaintenace);
  }, [props.underMaintenace]);

  const dataRelatorios = [["Excel"], ["PDF"], ["CSV"], ["KMZ"]];

  useEffect(() => {
    if (props.underMaintenace === "N") {
      setStartMaintenanceDate(new Date());
      setEndMaintenanceDate(null);
    } else {
      setStartMaintenanceDate(null);
      setEndMaintenanceDate(null);
    }
  }, [props.underMaintenace]);

  // useEffect(() => {
  //   if (token && vehicleSelected?.vehicleId && isPaging === false) {
  //     const dm = new DataManager({
  //       url: hostUrl,
  //       adaptor: new CustomAdaptor(),
  //       headers: [{ Authorization: `Bearer ${token.token}` }],
  //     });
  //     setData(dm);
  //   }
  // }, [vehicleSelected?.vehicleId])

  return (
    <>
      {dataLoading ? (
        <Spinner />
      ) : (
        <>
          <ToastComponent
            params={toastParams}
            closeToast={() => setToastParams(JSON.stringify({ show: false }))}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 8,
            }}
          >
            {showBackButton ? (
              <div className="back-to-fleet">
                <button
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => handleActiveTabGrid()}
                >
                  <div className="icon-back-fleet">
                    <IoMdArrowBack />
                  </div>
                  <span>Voltar</span>
                </button>
              </div>
            ) : (
              <div />
            )}

            {showTopFilters ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  gap: 16,
                }}
              >
                <ReportDropDown
                  vehicleId={props.vehicleId}
                  selectedVehicle={props.vehicleFilter}
                  loading={dataLoading}
                  startDate={startDate}
                  endDate={endDate}
                  groupId={selectedGroup?.value}
                  onToast={setToastParams}
                />

                <Filters
                  id={"veiculos"}
                  isMulti={false}
                  title={"Grupos"}
                  hasSubTitle={true}
                  subTitle={"Todos os grupos"}
                  options={dataGroup}
                  icon={HiOutlineRectangleGroup}
                  hasIcon={true}
                  pageTitle={"Posições Detalhadas"}
                  onManualSelection={() => setIsManualSelection(true)}
                />

                <Filters
                  id={"veiculosGroups"}
                  isMulti={false}
                  title={"Veículos"}
                  hasSubTitle={true}
                  subTitle={"Todos os veículos"}
                  options={dataVehicle}
                  icon={FaCar}
                  hasIcon={true}
                  pageTitle={"Posições Detalhadas"}
                  onManualSelection={() => setIsManualSelection(true)}
                  isLoading={filtersLoading}
                />
              </div>
            ) : null}
          </div>

          <div className="table-responsive" style={{ margin: 4 }}>
              {props.dataLoading ? (
                <Spinner />
              ) : (
                <div className="control-pane">
                  <div className="control-section">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginLeft: 4,
                        position: "relative",
                      }}
                    >
                      <SearchDetails
                        startDate={startDate}
                        setStartDate={setStartDate}
                        underMaintenace={localUnderMaintenace}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        vehicleId={vehicleSelected.vehicleId}
                        vehicleFilter={props.vehicleFilter}
                        dataLoading={dataLoading}
                        clear={clear} // ✅ sem parênteses
                        search={search} // ✅
                        handleActiveMaintenace={() =>
                          handleActiveMaintenace("maintenace")
                        } // ✅
                        handleActiveCommands={() =>
                          handleActiveCommands("commands")
                        } // ✅
                        handleShowCommands={() =>
                          handleShowCommands("commands")
                        } // ✅
                        refresh={refresh} // ✅
                        handleActiveTabGrid={handleActiveTabGrid}
                      />
                    </div>

                    {/* PoC: Layout visualization toggle buttons */}
                    <LayoutToggle
                      layoutMode={layoutMode}
                      onLayoutChange={setLayoutMode}
                    />

                    {dataGridPositions === 0 ? (
                      <div
                        className="alert alert-info"
                        style={{ margin: "20px", textAlign: "center" }}
                      >
                        <BiBox
                          size={50}
                          style={{ marginBottom: "10px", opacity: 0.5 }}
                        />
                        <div>
                          Nenhum dado encontrado para o período selecionado
                        </div>
                      </div>
                    ) : (
                      <div
                        className="card-positions"
                        style={{
                          display: "flex",
                          gap: 16,
                          height: "100%",
                          minHeight: "600px",
                        }}
                      >
                        {/* Grid - Show when not in map-only mode */}
                        {layoutMode !== "map-only" && (
                          <GridComponent
                            dataSource={dataGridPositions}
                            allowPaging={true}
                            ref={gridRef}
                            pageSettings={gridPageSettings}
                            locale="pt-BR"
                            id="gridcomp"
                            allowSorting={false}
                            allowFiltering={false}
                            width={layoutMode === "grid-only" ? "100%" : "70%"}
                            allowResizing={true}
                            rowHeight={30}
                            contextMenuItems={contextMenuItems}
                            contextMenuClick={onContextMenuClick}
                          >
                            <ColumnsDirective>
                              {effectiveFields.map((field, index) => (
                                <ColumnDirective
                                  {...getColumnProps(
                                    field,
                                    index,
                                    { ...props, columns: effectiveColumns, fields: effectiveFields },
                                    renderField,
                                    renderFilter
                                  )}
                                />
                              ))}
                              <ColumnDirective
                                key="actions"
                                headerText="Ações"
                                textAlign="Right"
                                width="50"
                                allowFiltering={false}
                                allowSorting={false}
                                template={renderMoreButton}
                              />
                            </ColumnsDirective>

                            <Inject
                              services={[
                                Resize,
                                Sort,
                                ContextMenu,
                                Page,
                                ExcelExport,
                                Edit,
                                PdfExport,
                                Filter,
                                Toolbar,
                              ]}
                            />
                          </GridComponent>
                        )}

                        {/* Map - Show when not in grid-only mode */}
                        {layoutMode !== "grid-only" && (
                          <Suspense fallback={<Spinner />}>
                            <PositionsMap
                              activeTab={props.activeTab}
                              mapLoading={props.mapLoading}
                              diaryPositions={registersMap}
                              handleClick={handleClick}
                              selectedIndex={selectedIndex}
                              onHandled={onHandled}
                              style={{
                                flex: layoutMode === "map-only" ? 1 : undefined,
                                width: layoutMode === "map-only" ? "100%" : "30%",
                              }}
                            />
                          </Suspense>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>

          {/* -- Manutenção -- */}
          <div
            className={`tab-pane fade  ${
              props.activeTab == "maintenace" ? "active show" : ""
            }`}
            style={props.activeTab == "maintenace" ? {} : { display: "none" }}
            id="navs-pills-top-profile"
            role="tabpanel"
          >
            <div>
              <Modal show={showMaintenanceModal} onHide={hideMaintenance}>
                <Modal.Header closeButton>
                  <Modal.Title>Informar manutenção</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 8,
                    }}
                  >
                    {maintenanceMessage && (
                      <p
                        style={{
                          color: "var(--text-success)",
                          fontWeight: "600",
                          margin: 0,
                          fontSize: "0.9rem",
                        }}
                      >
                        {maintenanceMessage}
                      </p>
                    )}
                  </div>
                  {localUnderMaintenace != "S" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 16,
                        margin: 8,
                        width: "100%",
                      }}
                    >
                      <p style={{ color: "var(--text-primary)", margin: 0 }}>
                        Data de manutenção
                      </p>
                      <div style={{ marginRight: 8, width: "100%" }}>
                        <SyncFusionDateTimePicker
                          id="datetimepickerStart"
                          value={startMaintenanceDate}
                          placeholder="Horário Inicial"
                          onChange={handleStartDateChange}
                          localUnderMaintenace={localUnderMaintenace}
                        />
                      </div>

                      <div style={{ marginRight: 8, width: "100%" }}>
                        <SyncFusionDateTimePicker
                          placeholder="Horário final"
                          id="datetimepickerEnd"
                          value={endMaintenanceDate}
                          onChange={handleEndDateChange}
                          localUnderMaintenace={localUnderMaintenace}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      style={{
                        color: "var(--text-primary)",
                        borderColor: "var(--text-primary)",
                      }}
                      onClick={async () =>
                        handleMaintenanceClick(vehicleSelected.vehicleId)
                      }
                      disabled={
                        localUnderMaintenace === "N" && !endMaintenanceDate
                      }
                    >
                      {localUnderMaintenace === "S" ? "Retirar" : "Registrar"}
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>

          {/* -- Historico de comandos -- */}
          <div
            className={`tab-pane fade  ${
              props.activeTab == "commands" ? "active show" : ""
            }`}
            style={props.activeTab == "commands" ? {} : { display: "none" }}
            id="navs-pills-top-profile"
            role="tabpanel"
          >
            <div>
              <Modal show={showCommandsModal} onHide={hideCommands}>
                <Modal.Header closeButton>
                  <Modal.Title>Histórico de comandos</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <p style={{ color: "var(--text-primary)" }}>Buscar por:</p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 16,
                      margin: 8,
                      width: "100%",
                    }}
                  >
                    <div style={{ marginRight: 8, width: "100%" }}>
                      <SyncFusionDateTimePicker
                        id="datetimepickerStart"
                        value={startCommandsDate}
                        placeholder="Horário Inicial"
                        onChange={setStartCommandsDate}
                      />
                    </div>

                    <div style={{ marginRight: 8, width: "100%" }}>
                      <SyncFusionDateTimePicker
                        placeholder="Horário final"
                        id="datetimepickerEnd"
                        value={endCommandsDate}
                        onChange={setEndCommandsDate}
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        style={{
                          color: "var(--text-primary)",
                          borderColor: "var(--text-primary)",
                        }}
                        onClick={() =>
                          handleSearchCommands(
                            startCommandsDate,
                            endCommandsDate
                          )
                        }
                        disabled={endCommandsDate < startCommandsDate}
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
            <div>
              <Modal
                show={showAvailableCommandsModal}
                onHide={hideAvailableCommands}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Comandos disponíveis</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 16,
                      margin: 8,
                      width: "100%",
                    }}
                  >
                    <table className="table table-grid" id="paginated-table">
                      <thead>
                        <tr>
                          <th key={0}>Comando</th>
                          <th key={0}>Enviar</th>
                        </tr>
                      </thead>
                      <tbody className="table-border-bottom-0">
                        {availableCommands?.map((item, index) => (
                          <tr key={index}>
                            <td>{item.descriptionCommand}</td>
                            <td>
                              <AiOutlineSend
                                cursor="pointer"
                                onClick={() => handleOpenConfirmModal(item)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>

          <div
            className={`tab-pane fade  ${
              props.activeTab == "commands" ? "active show" : ""
            }`}
            style={props.activeTab == "commands" ? {} : { display: "none" }}
            id="navs-pills-top-profile"
            role="tabpanel"
          >
            {/* -- Modal de Confirmação de Envio -- */}
            <Modal
              show={showConfirmModal}
              onHide={() => setShowConfirmModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirmar envio</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <p style={{ color: "var(--text-primary)" }}>
                  Você tem certeza do envio do comando{" "}
                  <strong>{commandToSend?.descriptionCommand}</strong> para o
                  veículo <strong>{selectedVehicleName}</strong>?
                </p>
              </Modal.Body>

              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowConfirmModal(false)}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmSend}
                >
                  Enviar comando
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default PaginatedTableFleetPositions;
